import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

const WordPressPosts = ({ postType = '', categories = [] }) => {
    const [posts, setPosts] = useState([]);
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const fetchPosts = async () => {
        setIsLoading(true);

        try {
            const response = await axios.get(
                `https://salvest.ee/wp-json/wp/v2/posts?per_page=3&offset=${offset}&categories=${categories.join(
                    ','
                )}`
            );
            const { data } = response;

            // Fetch featured image URLs for each post
            const postsWithImages = await Promise.all(
                data.map(async (post) => {
                    if (post.featured_media) {
                        const mediaResponse = await axios.get(
                            `https://salvest.ee/wp-json/wp/v2/media/${post.featured_media}`
                        );
                        const mediaData = mediaResponse.data;
                        return { ...post, featured_image_url: mediaData.source_url };
                    }
                    return post;
                })
            );

            setPosts((prevPosts) => [...prevPosts, ...postsWithImages]);
            setOffset(offset + 3);
            setHasMore(data.length >= 3);
        } catch (error) {
            console.error('Error loading more posts:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts();
    }, []); // Fetch posts on component mount

    const handleLoadMore = () => {
        fetchPosts();
    };

    const formatDate = (dateString) => {
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString('et-EE', options);
    };

    console.log(posts);
    return (
        <>
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8 md:gap-x-4 xl:gap-x-8 md:gap-y-16 mt-12 xl:mx-12">
            {posts.map((post) => (
                <a key={post.id} className="item-recipe" href={post.link}>
                    <div
                        className="relative h-80 w-full overflow-hidden rounded"
                        style={{ WebkitMaskImage: '-webkit-radial-gradient(white, black)' }}
                    >
                        {post.featured_image_url && (
                            <img
                                className="w-full h-full object-cover object-center"
                                src={post.featured_image_url}
                                alt={post.title.rendered}
                            />
                        )}
                    </div>
                    <h3 className="mt-6">{post.title.rendered}</h3>
                    <p className="text-aragon-900/[0.4] text-[14px] mb-2">{formatDate(post.date)}</p>
                    <p dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }}></p>
                </a>
            ))}
        </div>
            <div className="flex flex-wrap justify-center">
            {isLoading ? (
                <p>Laen...</p>
            ) : (
                hasMore &&
                    <button className="primary-button mt-12 arrow-right" onClick={handleLoadMore}>
                        Vaata rohkem
                    </button>

            )}
            </div>
        </>
    );
};

WordPressPosts.propTypes = {
    postType: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.number),
};

export default WordPressPosts;
